import React, { useState, useRef } from "react";
import {
  required,
  Create,
  SimpleForm,
  useRedirect,
  SelectInput,
  useNotify,
  FormDataConsumer,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import { CustomFileInput, ConfirmationModal } from "../../../components";
import * as S from "./index.styles";

const validateRequired = required();

const CustomToolbar = ({ onOpenModal, ...props }) => {
  const redirect = useRedirect();
  const { watch } = useFormContext();
  const labId = watch("labId");
  const file = watch("file");

  const isFormValid = labId && file;

  const handleCancel = () => {
    redirect("/orders/nfe-uploads");
  };

  const handleOpenConfirmModal = () => {
    if (isFormValid && onOpenModal) {
      onOpenModal();
    }
  };

  return (
    <S.StyledToolbar {...props}>
      <S.ToolbarCancelMuiButton onClick={handleCancel}>
        CANCELAR
      </S.ToolbarCancelMuiButton>
      <S.ToolbarSendMuiButton
        data-send-valid={isFormValid ? "true" : "false"}
        disabled={!isFormValid}
        onClick={handleOpenConfirmModal}
      >
        SALVAR
      </S.ToolbarSendMuiButton>
    </S.StyledToolbar>
  );
};


const NfeSampleUploadCreate = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const formRef = useRef(null);
  const notify = useNotify();


  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmSend = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      if (formRef.current) {
        const form = formRef.current.querySelector('form');
        if (form) {
          const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
          form.dispatchEvent(submitEvent);
        }
      }
    }, 100);
  };

  return (
    <>
      <Create {...props}>
        <div ref={formRef}>
          <SimpleForm
            toolbar={<CustomToolbar onOpenModal={handleOpenModal} />}
            className="nfe-sample-upload-create"
            sx={{ maxWidth: "100%", width: "100%" }}
          >
            <S.Container>
              <S.Header>
                <S.Title>Importação de Nota Fiscal</S.Title>
                <S.Subtitle>
                  Selecione o laboratório e faça upload do arquivo XML
                </S.Subtitle>
              </S.Header>

              <S.FormContainer>
                <S.StyledReferenceInput
                  source="labId"
                  reference="labs"
                  label="Laboratório"
                  perPage={999}
                  sort={{ field: 'name', order: 'ASC' }}
                  fullWidth
                  filter={{}}
                >
                  <SelectInput optionText="name" optionValue="id" validate={validateRequired} fullWidth label="Laboratório" />
                </S.StyledReferenceInput>

                <FormDataConsumer>
                  {({ formData }) => (
                    <CustomFileInput
                      source="file"
                      accept=".xml,application/xml"
                      validate={required()}
                      disabled={!formData?.labId}
                      className="nfe-sample-upload-create"
                      uploadText="Arraste o arquivo XML aqui ou clique para selecionar"
                      formatText="Formato aceito: .XML"
                      options={{
                        onDropRejected: () => notify("Arquivo inválido. Apenas arquivos .XML são aceitos.", { type: "error" })
                      }}
                    />
                  )}
                </FormDataConsumer>
              </S.FormContainer>
            </S.Container>
          </SimpleForm>
        </div>
      </Create>

      {/* Modal de Confirmação */}
      <ConfirmationModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmSend}
        title="Confirmar importação de nota fiscal"
        message="O arquivo XML será processado e os dados da nota fiscal serão importados para o sistema."
      />
    </>
  );
};

export default NfeSampleUploadCreate;
